var $ = require('jquery')
  , ShowPage = require('mobile/ui/showPage')
  , Video = require('widgets/Video')
  , rVideoHashId = /http:\/\/v.17173.com\/.+\/(.*)\.html/
  , rVideoHashIdSohu = /http:\/\/17173.tv.sohu.com\/.+\/(.*)\.html/
  , tmpl = require('./tmpl.handlebars')

$(function() {
  var section = $('.js-video')
  if (!section.length) { return }

  var src = section.data('src')
    , shtml
    , matched = src.match(rVideoHashId) || src.match(rVideoHashIdSohu)

  if (!matched || matched.length < 1) { return }

  var showPage = new ShowPage();
  section.click(function() {
    var video = new Video({
      videoUrl: src
    , height: '200'
    })
    var videoHtml = video.toHTML()
    showPage.show(tmpl({
      videoHtml: videoHtml
    }));
  })
})
